import { Program } from './program';

export class ProgramManufacturingOrder extends Program {
  constructor(
    hash: string,
    reference: string,
    time: number,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public manufacturingOrderProjectNumber?: string,
    public materialHash?: string,
    public materialFileName?: string
  ) {
    super(hash, reference, time);
  }

  get label() {
    if (this.manufacturingOrderCode && this.manufacturingOrderProjectNumber) {
      return `${ this.reference } (${ this.manufacturingOrderCode } / ${ this.manufacturingOrderProjectNumber })`;
    } else if (this.manufacturingOrderCode) {
      return `${ this.reference } (${ this.manufacturingOrderCode })`;
    } else {
      return this.reference;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/program-manufacturing-order.ts